<template lang="pug">

.ge-cnt.no-select(ref="cnt")

	Nav(v-if="isMedium && showNav" v-on-clickaway="clickedOutNav")
	Nav(v-else)
	transition(name="fade")
		.ge-cnt-body(ref="ge" v-show="(!showNav && isSmall && isContentReady) || !isSmall")
			Error(v-if="isError && isContentReady")
			transition(name="fade")
				Head(v-if="!isError && isContentReady")

			transition(name="fade")
				.ge-cnt-body-bottom(v-if="!isError && isContentReady" v-show="isHeadReady")
					transition(name="fade")
						router-view(v-if="isHeadReady" name="prematch")
					transition(name="fade")
						router-view(v-if="isHeadReady && !isUpcoming" name="overview")
					transition(name="fade")
						router-view(v-if="!isUpcoming" name="boxscore")
					transition(name="fade")
						router-view(v-if="!isUpcoming" name="leaders")
					transition(name="fade")
						router-view(v-if="!isUpcoming" name="globals")
					transition(name="fade")
						router-view(v-if="!isUpcoming" name="playbyplay")
					transition(name="fade")
						router-view(v-if="!isUpcoming" name="shootmap")
	BannerAcbApp
</template>

<script>

import { directive as onClickaway } from 'vue-clickaway'

import Nav from "@/components/Nav.vue"
import Head from "@/components/Head.vue"
import Overview from "@/components/Overview.vue"
import ShootMap from "@/components/ShootMap.vue"
import Playbyplay from "@/components/Playbyplay.vue"
import BoxScore from "@/components/BoxScore.vue"
import Globals from "@/components/Globals.vue"
import Leaders from "@/components/Leaders.vue"
import PreMatch from "@/components/PreMatch.vue"
import Error from "@/components/Error.vue"
import BannerAcbApp from "@/components/subcomponents/BannerAcbApp.vue"




export default {
	name: "App",
	metaInfo() {
		return {
			title: (this.$store.state.match.localAbbrev && this.$store.state.match.visitorAbbrev) ? `${this.$store.state.match.localAbbrev} - ${this.$store.state.match.visitorAbbrev} | ACB Live` : 'ACB Live',
			meta: [
				{
					name: 'description',
					content: this.$i18n.t('meta_description')
				}
			]
		}
	},
	// data() {
	// 	return  {
	// 		lastUserInteraction: new Date().getTime(),
	// 		inactivityTimer: null
	// 	}
	// },
	computed: {
		location() {
			if (window.location.href) {
				return window.location.href
			} else {
				return 'none'
			}
		},
		isHeadReady() {
			return this.$store.state.general.isHeadReady
		},
		isContentReady() {
			return this.$store.state.general.isContentReady
		},
		isError() {
			return this.$store.state.general.error
		},
		isSmall() {
			return this.$store.state.general.isSmall
		},
		isMedium() {
			return this.$store.state.general.isMedium
		},
		isLarge() {
			return this.$store.state.general.isLarge
		},
		showNav() {
			return this.$store.state.general.showNav
		},
		isMatchSelected() {
			return !!this.$route.params.id_match
		},
		isUpcoming() {
			return this.$store.state.match.status == 'upcoming'
			// return false
		},
		isRoasterReady() {
			return this.$store.state.match.status == 'roaster-ready'
		},
		isOverview() {
			return this.$route.name.includes('overview')
		},
		idMatch() {
			return this.$route.params.id_match
		},
		isTop() {
			return this.$store.state.general.isTop
		},
		headHeight() {
			return this.$store.state.general.headHeight
		},
		baseHeadHeight() {
			return this.$store.state.general.baseHeadHeight
		},
		collapsedHeight() {
			return this.$store.state.general.collapsedHeight
		},
		scrollTop() {
			return this.$store.state.general.scrollTop
		},
		contentBodyWidth() {
			return { width: `${this.$store.state.general.contentBodyWidth}px` }
		},
		quarterNum() {
			return this.$store.state.match.quarterNum;
		}
	},
	methods: {
		clickedOutNav() {
			if (this.isMedium && this.showNav) {
				this.$store.commit('general/setNav', 0)
			}
		},
		triggerGlobalRefresh() {
			this.$store.commit('general/deactivateRefreshSignal')
			this.$store.commit('general/clearRefreshSignal')
			setTimeout(() => {
				this.$store.commit('general/activateRefreshSignal')
				this.$store.commit('general/setRefreshSignal')
			}, 5);
		},
		goTop() {
			// this.$refs.ge.scrollTop = 0
			if (this.scrollTop > (this.headHeight - this.collapsedHeight)) {
				this.$refs.ge.scrollTop = (this.headHeight - this.collapsedHeight)
				// if (this.isSmall) {
				// 	this.$refs.ge.scrollTop = (this.headHeight - this.collapsedHeight)
				// } else if (this.isMedium) {
				// 	this.$refs.ge.scrollTop = (this.headHeight - this.collapsedHeight)
				// } else {
				// 	this.$refs.ge.scrollTop = (this.headHeight - this.collapsedHeight)
				// }
			}
		},
		// checkInactivityTimer() {
		// 	if (!this.$store.state.general.isApp){
		// 		if (new Date().getTime() - this.lastUserInteraction >= 180000) {
		// 			clearTimeout(this.inactivityTimer);
		// 			window.location.reload();
		// 		} else {
		// 			this.inactivityTimer = setTimeout(this.checkInactivityTimer, 1000);
		// 		}
		// 	}
		// },
	},
	watch: {
		idMatch(newValue) {
			this.$store.commit('general/setContentReady', false)
			this.$store.commit("general/setHeadReady", false);
			this.$store.commit('general/setScrollTop', 0)
			this.$refs.ge.style.display = "none"
			if (newValue) {
				this.$store.dispatch('match/loadMatchData', newValue).then(() => {
					this.$refs.ge.style.display = ""
					// this.$store.commit('general/setContentReady',true)
				})
			}
			// Show header after Xs (to handle connection issues)
			setTimeout(() => { this.$store.commit("general/setHeadReady", true) }, 3000)
		},
		isRoasterReady(newValue) {
			if (newValue) {
				this.$router.replace({ name: this.$store.state.general.lang + '.boxscore' })
			}
		},
		refreshSignal(newValue) {
			if (newValue && this.$route.params.id_match) {
				if (this.$store.state.match.status == "upcoming")
					this.$store.dispatch('match/loadMatchData', this.$route.params.id_match)
			}
		}
	},
	components: {
		Nav,
		Head,
		Overview,
		ShootMap,
		Playbyplay,
		BoxScore,
		Globals,
		Leaders,
		PreMatch,
		Error,
		BannerAcbApp,
	},
	mounted() {
		this.$store.commit('general/setScreenSize', window.innerWidth)
		window.addEventListener('resize', () => {
			this.$store.commit('general/setScreenSize', window.innerWidth)
			this.$store.commit('general/setContentBodyWidth', this.$refs.ge.offsetWidth)
			// this.$store.commit('general/setBaseHeadHeight')
		})
		this.$refs.ge.addEventListener('touchmove', this.preventDefault, () => {
			this.$store.commit('general/setScrollTop', this.$refs.ge.scrollTop)
			// this.lastUserInteraction = new Date().getTime()
		}, { passive: false })
		this.$refs.ge.addEventListener('scroll', () => {
			this.$store.commit('general/setScrollTop', this.$refs.ge.scrollTop)
		},)
		// this.$refs.cnt.addEventListener('mouseover',  () => {
		// 	this.lastUserInteraction = new Date().getTime()
		// }, )
		// this.$refs.cnt.addEventListener('touchstart',  () => {
		// 	this.lastUserInteraction = new Date().getTime()
		// }, )
		if (this.isLarge) {
			this.$store.commit('general/setContentBodyWidth', window.innerWidth - 350)
		} else {
			this.$store.commit('general/setContentBodyWidth', window.innerWidth)
		}
		this.$i18n.locale = this.$store.state.general.lang
		this.$store.commit('general/setRefreshSignal')

		// Inactivity check
		// this.inactivityTimer = setTimeout(this.checkInactivityTimer, 1000);

		// Update store scroll position to avoid head freeze
		// setInterval(this.$store.commit('general/setScrollTop',this.$refs.ge.scrollTop), 500);

		document.getElementsByTagName("BODY")[0].setAttribute("live", "True")

	},
	created() {
		this.$store.commit('general/setContentReady', false)
		this.$store.dispatch('match/loadMatchData', this.$route.params.id_match)

	},
	beforeDestroy() {
		document.getElementsByTagName("BODY")[0].removeAttribute("live",)

	},
	// destroyed() {
	// 	clearTimeout(this.inactivityTimer);
	// },
	directives: {
		onClickaway: onClickaway,
	},

}
</script>